import InvoiceList from 'Components/Invoices/InvoiceList';
import { LpBox } from 'Constants/styles';

type Props = {
  merchantId: string;
};

const MerchantInvoicesList = ({ merchantId }: Props) => {
  return (
    <LpBox>
      <InvoiceList merchantId={merchantId} />
    </LpBox>
  );
};

export default MerchantInvoicesList;
